/**
* Migrations for an individual "EventIdentityConfirmation" widget of the event site editor website layout item.
* - Migrate new style settings onto EventIdentityConfirmation widgets.
*/
export default function contactPlannerWidgetMigrations(identityConfirmation) {
  if (identityConfirmation.config.style.instructionalTextStyle
      && identityConfirmation.config.style.headerTextStyle) {
    return identityConfirmation;
  }

  const newStyle = {};
  if (!identityConfirmation.config.style.instructionalTextStyle) {
    newStyle.instructionalTextStyle = {
      styleMapping: 'body1',
      customSettings: {
        text: {
          textAlign: 'center'
        }
      }
    };
  }
  if (!identityConfirmation.config.style.headerTextStyle) {
    newStyle.headerTextStyle = {
      styleMapping: 'header2',
      customSettings: {
        text: {
          textAlign: 'center'
        }
      }
    };
  }

  return {
    ...identityConfirmation,
    config: {
      ...identityConfirmation.config,
      style: {
        ...identityConfirmation.config.style,
        ...newStyle
      }
    }
  };
}
